import AuthActionStatus from './AuthActionStatus';

function AuthActionExpired() {
  return (
    <AuthActionStatus
      heading="That confirmation link has expired"
      body="No problem. Open I’d Tap That and use Resend email to get a new confirmation link."
    />
  );
}

export default AuthActionExpired;
